import { useParams } from 'libs/router'
import { useAxiosPrivate } from 'shared/hooks'
import { useQuery } from 'libs/query'
import { UserRes } from 'features/users/types/users.types'
import { apiRoutes } from 'config/apiRoutes'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'

export const useFetchUser = () => {
	const params = useParams()
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const { data: userData, isSuccess: isUserSuccess } = useQuery<UserRes>({
		queryKey: queryKeys.users.detail(params.id as string),
		queryFn: () => axiosPrivate.get(apiRoutes.user(params.id as string)),
		enabled: !!auth.accessToken
	})

	return {
		user: userData?.data,
		isUserSuccess
	}
}
